<template>
  <div class="main-slider" :class="{ 'is-hero-heading': heading }">
    <!-- Slider main container -->
    <div class="swiper">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->

        <div v-for="(item, index) in slides" :key="`hero-slide-${index}-${_uid}`" class="swiper-slide">
          <div class="main-slider-container" :class="[item.class_bg]">
            <div class="main-slider-wrapper container">
              <div class="main-slider-content" ref="content">
                <div class="main-slider-image" :class="fillColor(item)">
                  <div :style="{
                    backgroundImage: `url(${item.image})`,
                  }" class="main-slider-background"></div>
                  <div class="main-slider-svg">
                    <svg viewBox="0 0 1203.23404 1466.04255">
                      <defs>
                        <mask id="mask">
                          <rect width="1203.23404" height="1466.04255" fill="white" />
                        </mask>
                      </defs>
                      <g>
                        <path mask="url(#mask)" fill="currentColor"
                          d="M609.34865,399.77648l144.01001,271.9898c7.10999,13.68701,10.18994,33.94901,7.6499,52.73401l-2.02002,11.67401c-1.46997,6.57498-4.0199,12.61298-6.56995,17.71198l-128.31995,227.30701c-14.75,12.211-33.52002,19.323-48.68005,19.323h-.53003l-258.12695-3.48901c-24.27002-.53699-54.70898-19.72498-66.375-42.13397l-125.77704-237.90701c-11.66595-22.27399-11.66595-59.84601,1.073-82.254l131.81104-234.4191c12.203-21.8719,42.64099-40.12088,66.375-40.12088h1.07001l244.31995,3.62296c.53003,1.07348,1.47009,1.47604,2.54004,2.01278,16.77002,8.18518,30.43994,20.79844,37.55005,33.94844ZM811.68861,787.43229c12.19995-21.87201,42.64001-40.12003,66.91003-40.12003h.53992l216.56006-7.64899c28.41992-.53699,62.34998-20.798,76.55994-46.159l22.26001-39.048c1.47998-2.54901,1.07007-6.03799-1.46997-8.185-2.55005-2.01199-5.64001-2.01199-8.18005,0-15.15991,12.61401-33.92993,19.72501-50.1499,20.26199l-257.59009-3.48898c-24.2699-.53601-54.70996-19.32202-66.38-42.13301l-125.7699-237.9078c-11.67004-22.27444-11.13-60.3826,1.06995-82.2545l131.81006-234.41871c12.19995-21.87198,42.63989-40.121,66.37988-40.121h1.07007l244.30994,3.62302c3.49011,0,5.63-2.013,6.04004-5.099.53003-3.086-1.07996-6.03799-3.48999-7.11099-10.18994-4.026-19.70996-6.57501-28.95996-6.57501l-294.59998-4.026h-1.07007c-28.42993,0-63.42993,20.798-77.64001,46.159l-150.58997,267.4279c-4.56006,7.6484-7.64001,17.1755-9.65002,27.3734-10.58997-2.0127-22.26001-3.0862-26.81995-3.0862l-294.59705-4.0255h-1.073c-28.427,0-63.42499,20.79843-77.50397,46.1591L19.21461,654.45627c-14.75,25.89801-15.15204,68.03201-1.073,94.332l143.47699,271.45297c13.67798,26.43402,48.67499,48.17206,77.10297,48.70801l294.59705,4.026c9.65002,1.073,20.25-2.013,30.43994-6.57495-4.55994,23.34796-2.01001,50.185,8.04004,68.43298l143.47998,271.45801c13.68005,26.42993,48.68005,48.16992,77.09998,48.69995l294.6001,4.03003h1.06995c28.43005,0,63.43005-20.80005,77.51001-46.16003l21.84998-39.04999c1.47998-2.54999,1.07996-6.02997-1.46997-8.18201-2.55005-2.013-5.63-2.013-8.18005,0-15.1499,12.612-33.92993,20.26202-49.20996,20.26202h-.54004l-257.58997-3.62c-24.27002-.53998-54.70996-19.72803-66.37-42.13702l-125.78003-237.90698c-11.65991-22.27496-11.65991-60.383,1.07007-82.255l132.34998-232.94199v.40201Z"
                          stroke-width="0" />
                      </g>
                      <g>
                        <path mask="url(#mask)" class="is-multiply" fill="currentColor"
                          d="M609.34865,399.77648l144.01001,271.9898c7.10999,13.68701,10.18994,33.94901,7.6499,52.73401l-2.02002,11.67401c-1.46997,6.57498-4.0199,12.61298-6.56995,17.71198l-128.31995,227.30701c-14.75,12.211-33.52002,19.323-48.68005,19.323h-.53003l-258.12695-3.48901c-24.27002-.53699-54.70898-19.72498-66.375-42.13397l-125.77704-237.90701c-11.66595-22.27399-11.66595-59.84601,1.073-82.254l131.81104-234.4191c12.203-21.8719,42.64099-40.12088,66.375-40.12088h1.07001l244.31995,3.62296c.53003,1.07348,1.47009,1.47604,2.54004,2.01278,16.77002,8.18518,30.43994,20.79844,37.55005,33.94844ZM811.68861,787.43229c12.19995-21.87201,42.64001-40.12003,66.91003-40.12003h.53992l216.56006-7.64899c28.41992-.53699,62.34998-20.798,76.55994-46.159l22.26001-39.048c1.47998-2.54901,1.07007-6.03799-1.46997-8.185-2.55005-2.01199-5.64001-2.01199-8.18005,0-15.15991,12.61401-33.92993,19.72501-50.1499,20.26199l-257.59009-3.48898c-24.2699-.53601-54.70996-19.32202-66.38-42.13301l-125.7699-237.9078c-11.67004-22.27444-11.13-60.3826,1.06995-82.2545l131.81006-234.41871c12.19995-21.87198,42.63989-40.121,66.37988-40.121h1.07007l244.30994,3.62302c3.49011,0,5.63-2.013,6.04004-5.099.53003-3.086-1.07996-6.03799-3.48999-7.11099-10.18994-4.026-19.70996-6.57501-28.95996-6.57501l-294.59998-4.026h-1.07007c-28.42993,0-63.42993,20.798-77.64001,46.159l-150.58997,267.4279c-4.56006,7.6484-7.64001,17.1755-9.65002,27.3734-10.58997-2.0127-22.26001-3.0862-26.81995-3.0862l-294.59705-4.0255h-1.073c-28.427,0-63.42499,20.79843-77.50397,46.1591L19.21461,654.45627c-14.75,25.89801-15.15204,68.03201-1.073,94.332l143.47699,271.45297c13.67798,26.43402,48.67499,48.17206,77.10297,48.70801l294.59705,4.026c9.65002,1.073,20.25-2.013,30.43994-6.57495-4.55994,23.34796-2.01001,50.185,8.04004,68.43298l143.47998,271.45801c13.68005,26.42993,48.68005,48.16992,77.09998,48.69995l294.6001,4.03003h1.06995c28.43005,0,63.43005-20.80005,77.51001-46.16003l21.84998-39.04999c1.47998-2.54999,1.07996-6.02997-1.46997-8.18201-2.55005-2.013-5.63-2.013-8.18005,0-15.1499,12.612-33.92993,20.26202-49.20996,20.26202h-.54004l-257.58997-3.62c-24.27002-.53998-54.70996-19.72803-66.37-42.13702l-125.78003-237.90698c-11.65991-22.27496-11.65991-60.383,1.07007-82.255l132.34998-232.94199v.40201Z"
                          stroke-width="0" />
                      </g>
                    </svg>
                  </div>
                </div>
                <div class="main-slider-info" ref="info" :class="item.class_text">
                  <div class="main-slider-info__content">
                    <h2 v-if="item.title">{{ item.title }}</h2>
                    <div v-if="item.description" class="main-slider-info__description" v-html="item.description"></div>
                  </div>
                  <a v-if="item.link && item.link.link" :href="item.link.link" :class="[
                    'button',
                    item.class_button
                      ? item.class_button
                      : 'has-background-green has-text-dark',
                  ]">
                    {{ item.link.text }}
                    <i class="icon icon-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="!heading">
        <!-- If we need navigation buttons -->
        <div class="ms-arrows container">
          <button class="ms-arrow ms-left">
            <i class="ms-arrow-icon" v-icon:arrow-left-alt></i>
          </button>
          <button class="ms-arrow ms-right">
            <i class="ms-arrow-icon" v-icon:arrow-right-alt></i>
          </button>
        </div>

        <div class="ms-pagination"></div>
      </template>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export default {
  name: "VMainBanner",
  props: {
    items: {
      type: Array,
      required: true,
    },
    heading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.onInit();
    if (this.heading)
      this.onHeading();
  },
  computed: {
    slides() {
      const result = this.shuffle(this.items);
      return this.heading ? [result[0]] : result;
    },
  },
  methods: {
    onHeading() {
      const $top = document.getElementById("Top");
      const $infoHeading = document.getElementById("InfoHeading");

      const $content = this.$refs['content'][0];
      const $info = this.$refs['info'][0];

      $content.insertBefore($top, $info);
      $info.insertBefore($infoHeading, $info.querySelector('.main-slider-info__content'));
      $top.setAttribute("class", this.slides[0].class_text);
    },
    shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    fillColor(item) {
      return item.class_bg.replace("background", "text");
    },
    onInit() {
      const $swiper = this.$el.querySelector(".swiper");

      if ($swiper) {
        const nextEl = this.$el.querySelector(".ms-right");
        const prevEl = this.$el.querySelector(".ms-left");

        const config = {
          effect: "fade",
          speed: 500,
          modules: [Navigation, EffectFade, Pagination],
          loop: true,
        };

        if (!this.heading) {
          config.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
          };
          config.pagination = {
            el: this.$el.querySelector(".ms-pagination"),
            clickable: true,
          };
        }

        new Swiper($swiper, config);
      }
    },
  },
};
</script>
